var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AbExperimentsApi: () => AbExperimentsApi
});
module.exports = __toCommonJS(src_exports);

// ../../node_modules/js-cookie/dist/js.cookie.mjs
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
  }
  function get(key) {
    if (typeof document === "undefined" || arguments.length && !key) {
      return;
    }
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {
      }
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set,
    get,
    remove: function(key, attributes) {
      set(key, "", assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function(converter2) {
      return init(assign({}, this.converter, converter2), this.attributes);
    }
  }, {
    attributes: { value: Object.freeze(defaultAttributes) },
    converter: { value: Object.freeze(converter) }
  });
}
var api = init(defaultConverter, { path: "/" });
var js_cookie_default = api;

// src/constants.ts
var PROJECT_ID = "project_id";
var EXPERIMENT_GROUP_COOKIE_NAME = "experiment_group";

// src/libs/createTimeoutController.ts
function createTimeoutController(ms) {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ms);
  return controller;
}

// src/index.ts
var AbExperimentsApi = class {
  product;
  userId;
  conditions = [];
  options = {
    timeout: 3e3,
    endPoint: "https://ab.xsolla.com/v2/group"
  };
  constructor(experimentInfo, options) {
    this.product = experimentInfo.product;
    this.userId = experimentInfo.userId;
    this.options = { ...this.options, ...options };
    this.addConditions({ name: PROJECT_ID, value: experimentInfo.projectId });
  }
  addConditions(...conditions) {
    this.conditions.push(...conditions);
  }
  async fetchGroup() {
    const payload = {
      product: this.product,
      user_id: this.userId,
      conditions: this.conditions,
      experiment_group: js_cookie_default.get(EXPERIMENT_GROUP_COOKIE_NAME)
    };
    const group = await this.fetchGroupFromABService(payload);
    if (group.datetime_end) {
      js_cookie_default.set(EXPERIMENT_GROUP_COOKIE_NAME, group.experiment_group, {
        expires: new Date(group.datetime_end)
      });
    }
    return group.experiment_group;
  }
  async fetchGroupFromABService(payload) {
    const res = await fetch(this.options.endPoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload),
      signal: createTimeoutController(this.options.timeout).signal
    }).catch((err) => {
      throw err;
    });
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    return res.json();
  }
};
/*! js-cookie v3.0.1 | MIT */
